import React from 'react';

/**
 * 목록을 펼치는 **꺾쇠**.
 *
 * 예전에는 글자 `▶`(U+25B6) 를 그대로 썼다. 그런데 **아이폰에서는 이 글자가 이모지로
 * 바뀌어** 파란 네모 재생단추처럼 나온다(실측: 모바일 다크모드 목록의 오른쪽 단추).
 * 이모지로 그려지면 `color` 도 안 먹어서 어느 화면에서든 파랗게 뜬다.
 *
 * 그래서 글자가 아니라 그림으로 그린다. 크기는 `1em` 이라 부모의 `fontSize` 를 그대로
 * 따르고, 색은 `currentColor` 라 부모의 `color` 를 따른다 — 쓰던 자리에 그대로 끼운다.
 */
export default function Caret({ style }: { style?: React.CSSProperties }) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 10 10"
            aria-hidden="true"
            style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
        >
            <path d="M3.2 1.4 L7.4 5 L3.2 8.6 Z" fill="currentColor" />
        </svg>
    );
}
